<template>
  <section class="sectors-tab">
    <h3>Sector investing support</h3>
    <h5>
      Access sector reports and insights that can inform your investment
      decisions
    </h5>

    <div class="sector-cards">
      <div @click="navigate('connectivity')" class="sector-card">
        <h5 class="card-title">Connectivity</h5>
        <img
          alt="Profile icon"
          src="media/icons/custom/connectivity.svg"
          class="me-2"
        />
      </div>
      <div @click="navigate('healthcare')" class="sector-card">
        <h5 class="card-title">Healthcare</h5>
        <img
          alt="Profile icon"
          src="media/icons/custom/healthcare.svg"
          class="me-2"
        />
      </div>
      <div @click="navigate('creative')" class="sector-card">
        <h5 class="card-title">Creative Industries</h5>
        <img
          alt="Profile icon"
          src="media/icons/custom/creative.svg"
          class="me-2"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "sectors-tab",
  methods: {
    navigate(sector) {
      this.$router.push(`/sectors/${sector}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.sectors-tab {
  color: #fff;
  text-align: center;
  h3 {
    color: #fff;
    font-size: 40px;
    margin-bottom: 27px;
  }
  h5 {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 30px;
  }
}
.sector-cards {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.sector-card {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 6px;
  min-width: 300px;
  padding: 30px 0px;
  margin: 10px;
  cursor: pointer;
  img {
    width: 25px;
  }
  h5 {
    font-weight: 500;
    font-size: 18px;
    line-height: 35px;
    color: #0e3167;
    font-weight: 600;
    margin-bottom: 10px;
  }
}
</style>
